import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { printAPIPDF } from "../helpers/AxiosInstance";
interface IUsePostHook {
  queryKey: string[];
  navigateURL?: string;
}
const usePDFPrintHook = (props: IUsePostHook) => {
  const { queryKey } = props;
  //  Getting cached data from queryClient
  const queryClient = useQueryClient();

  const {
    isLoading: isPostLoading,
    mutateAsync,
    isSuccess: isPostSuccess,
    data: postData,
    isError: isPostError,
  } = useMutation(printAPIPDF, {
    onSuccess: async (data) => {
      console.log(data, "data")
    },
    onError: (error) => {
      toast.error("Error");
    },

    onSettled: async () => {
      queryClient.invalidateQueries(queryKey);
    },
  });
  return {
    isPostLoading,
    mutateAsync,
    isPostSuccess,
    postData,
    isPostError,
  };
};

export default usePDFPrintHook;
